import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _get from "lodash/get";
import _toUpper from "lodash/toUpper";
import _find from "lodash/find";
import _isNil from "lodash/isNil";
import _noop from "lodash/noop";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { ExerciseStatus } from '@datacamp/exercise-contract';
import * as React from 'react';
import MultiplexerSessionManager, { MULTIPLEXER_STATUS } from '../lib/MultiplexerSessionManager';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const MultiplexerContext = React.createContext({
  error: undefined,
  multiplexerSessionManager: undefined,
  multiplexerUrl: '',
  outputs: [],
  restartSession: _noop,
  status: MULTIPLEXER_STATUS.NONE
});
export const defaultInitialState = {
  error: undefined,
  forceNew: false,
  multiplexerSessionManager: undefined,
  multiplexerUrl: '',
  outputs: [],
  retries: 0,
  status: MULTIPLEXER_STATUS.NONE
};
export const getDefaultReducer = function () {
  let initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultInitialState;
  return (
    // eslint-disable-next-line consistent-return
    (state, action) => {
      // eslint-disable-next-line default-case
      switch (action.type) {
        case 'restartSession':
          return _objectSpread(_objectSpread({}, initialState), {}, {
            forceNew: true,
            retries: state.retries + 1
          });
        case 'startSession':
          return _objectSpread(_objectSpread({}, initialState), {}, {
            multiplexerSessionManager: action.multiplexerSessionManager,
            multiplexerUrl: action.multiplexerUrl,
            retries: state.retries
          });
        case 'setStatus':
          {
            const error = action.status === MULTIPLEXER_STATUS.BROKEN ? new Error('session broken') : undefined;
            return _objectSpread(_objectSpread({}, state), {}, {
              error,
              status: action.status
            });
          }
        case 'getNewOutputs':
          return _objectSpread(_objectSpread({}, state), {}, {
            outputs: state.outputs.concat(action.outputs)
          });
      }
    }
  );
};
export const Multiplexer = _ref => {
  let {
    checkExercise,
    children,
    environment,
    exercise,
    initialState = defaultInitialState,
    onExerciseStatusUpdate,
    reducer = getDefaultReducer(initialState),
    type,
    user
  } = _ref;
  const [state, dispatch] = React.useReducer(reducer, initialState);
  React.useEffect(() => {
    if (_isNil(user) || _isNil(exercise)) {
      return _noop;
    }
    const outputSubscriber = (outputs, lastSubmittedCode) => {
      dispatch({
        outputs,
        type: 'getNewOutputs'
      });
      const feedback = _find(outputs, output => output.type === 'sct');
      if (!_isNil(feedback)) {
        checkExercise(feedback.payload.message, feedback.payload.correct, lastSubmittedCode);
      }
    };
    const multiplexerSessionManager = new MultiplexerSessionManager(user, type, environment, exercise, outputSubscriber, state.forceNew);
    multiplexerSessionManager.subscribeToStatus(status => {
      onExerciseStatusUpdate({
        id: exercise.id,
        status: ExerciseStatus[_toUpper(status)]
      });
      dispatch({
        status,
        type: 'setStatus'
      });
    });
    dispatch({
      multiplexerSessionManager,
      multiplexerUrl: multiplexerSessionManager.multiplexerUrl,
      type: 'startSession'
    });
    multiplexerSessionManager.start();
    return () => {
      multiplexerSessionManager.stop();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.retries, user, _get(exercise, 'id')]);
  const restartSession = React.useCallback(() => {
    dispatch({
      type: 'restartSession'
    });
  }, []);
  return ___EmotionJSX(MultiplexerContext.Provider, {
    value: {
      error: state.error,
      multiplexerSessionManager: state.multiplexerSessionManager,
      multiplexerUrl: state.multiplexerUrl,
      outputs: state.outputs,
      restartSession,
      status: state.status
    }
  }, children);
};